import { ApiResponse } from '@/models/api'
import client from './index'

import { CreateGolfAdminAccount, GolfAdmin } from '@/models/golfAdmin'

export default {
  usersList() {
    return client.get<ApiResponse<GolfAdmin[]>>('/golf-admins')
  },

  inviteUser(params: CreateGolfAdminAccount) {
    return client.post<ApiResponse<null>>('/golf-admins', params)
  },

  updateUserStatus(
    id: string,
    params: Pick<GolfAdmin, 'golf_role' | 'golf_status'>
  ) {
    return client.put<ApiResponse<GolfAdmin>>(`/golf-admins/${id}`, params)
  },
}
